import { useFiltersService } from '../../../hooks/inventory/useFilters';
import { StoreContext } from '../../../context/Provider';
import {
  IFilterOptions,
  ISamInventory,
  iSandboxFilterData,
} from '../../../interfaces/service/SandboxServiceManagerInterface';
import { ChangeEventHandler, useContext, useEffect, useState } from 'react';
import { useSamTypes } from '../../../hooks/inventory/useSamTypes';
import { useSandbox } from '../../../hooks/sandbox/useSandbox';
import { createQueryParams } from '../../../utils/utils';
import { defaultColumnsSandboxTable } from '../../../pages/Sandbox/components/utils';
import { ColumnConfigWithBody } from '../../../interfaces/interfaceReassignment';
import { MultiSelectChangeEvent } from 'primereact/multiselect';
import { ToastComponent } from '../../../components/ToastComponent';
const initialValuesFilterData = {
  samValueSelected: [],
  projectValueSelected: [],
  operatorsValueSelected: [],
  samIdValue: '',
};
export const useSandboxProvider = () => {
  const {
    getCatalogProjectsState,
    getCatalogDeviceState,
    getCatalogOperatorsState,
    getSamTypesStates,
    getSandboxState,
  } = useContext(StoreContext);
  const [openRightMenu, setOpenRightMenu] = useState<boolean>(false);
  const [filtersData, setFiltersData] = useState<iSandboxFilterData>(
    initialValuesFilterData
  );
  const [filterOptions, setFilterOptions] = useState<IFilterOptions>({
    operatorsList: [],
    projectsList: [],
    samTypeList: [],
  });

  const [columnsSelected, setColumnsSelected] = useState<
    ColumnConfigWithBody[]
  >(defaultColumnsSandboxTable);

  const [tableData, setTableData] = useState<ISamInventory[]>([]);
  useFiltersService();
  useSamTypes();
  const { getSandBoxData, sandboxExportExcel } = useSandbox('');

  useEffect(() => {
    if (getCatalogOperatorsState.state.data !== null) {
      setFilterOptions({
        ...filterOptions,
        operatorsList: getCatalogOperatorsState.state.data,
      });
    }
    if (getCatalogProjectsState.state.data !== null) {
      setFilterOptions({
        ...filterOptions,
        projectsList: getCatalogProjectsState.state.data,
      });
    }

    if (getSamTypesStates.state.data !== null) {
      setFilterOptions({
        ...filterOptions,
        samTypeList: getSamTypesStates.state.data,
      });
    }
  }, [
    getCatalogOperatorsState.state,
    getCatalogProjectsState.state,
    getSamTypesStates.state,
  ]);

  function queryParamsDataToSend(
    isSandbox: boolean = false,
    isToExport: boolean = false
  ) {
    let queryParams: string[] = [];
    const addParams = (selectedArray: any[], paramName: string) => {
      if (selectedArray.length > 0) {
        selectedArray.forEach(element => {
          queryParams.push(`${paramName}=${encodeURIComponent(element.name)}`);
        });
      }
    };
    addParams(filtersData.operatorsValueSelected, 'technologicalOperator');
    addParams(filtersData.projectValueSelected, 'project');
    addParams(filtersData.samValueSelected, 'samType'); // Add samIds field if not empty
    if (filtersData.samIdValue !== '') {
      queryParams.push(`samIds=${encodeURIComponent(filtersData.samIdValue)}`);
    }
    if (isToExport) {
      queryParams.push(`samIds=${isSandbox}`);
    }

    const queryRequest = queryParams.join('&');
    return queryRequest;
  }

  useEffect(() => {
    if (getSandboxState.state.data !== null) {
      setTableData(getSandboxState.state.data);
    }
  }, [getSandboxState.state]);

  function onChangeFilterData(changeValue: any) {
    const { name, value } = changeValue?.target || {};

    setFiltersData({
      ...filtersData,
      [name]: value,
    });
  }

  function onClickSendData() {
    const params = queryParamsDataToSend();

    return getSandBoxData(params);
  }
  function onExportExcel() {
    if (tableData.length === 0) {
      ToastComponent('info', 'No hay datos para exportar', '');
      return;
    }
    const columnsQueryParams = createQueryParams(
      'columnsToDisplay',
      columnsSelected.map((item: any) => item.field)
    );
    const queryParams = queryParamsDataToSend(true, true);
    return sandboxExportExcel(columnsQueryParams, queryParams);
  }

  function handleSelectColumn(e: MultiSelectChangeEvent) {
    setColumnsSelected(e.value);

    e.stopPropagation();
  }
  return {
    openRightMenu,
    setOpenRightMenu,
    filtersData,
    onChangeFilterData,
    filterOptions,
    onClickSendData,
    onExportExcel,
    tableData,
    handleSelectColumn,
    columnsSelected,
  };
};
